module.exports = __webpack_public_path__ + "img/11_non_close_L2.9a0e05a0.svg";